export const table_titles = [
	{ name: "#", size: 5, order: "" },
	{ name: "Nombre", size: 10, order: "name" },
	{ name: "Antetítulo", size: 40, order: "name" },
	{ name: "Título", size: 40, order: "name" },
	{ name: "Acción", size: 5, order: "" },
];

export const base_list = {
	page: 1,
	paginate: 100,
	order: "name",
	orderType: "desc",
};

export const base_element = {
	id: "",
	name: "",
	pretitle: "",
	title: "",
	url_media: "",
	details: [],
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};
